import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, withKeys as _withKeys, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d16597fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nge-blog-head" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Blog", -1 /* HOISTED */))
const _hoisted_3 = { class: "nge-blog-head-actions" }
const _hoisted_4 = {
  key: 0,
  class: "nge-blog-problem",
  role: "alert"
}
const _hoisted_5 = {
  key: 1,
  class: "nge-blog-note"
}
const _hoisted_6 = {
  key: 2,
  class: "nge-blog-note"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "nge-blog-row-title" }
const _hoisted_9 = { class: "nge-blog-row-meta" }
const _hoisted_10 = { class: "nge-blog-head" }
const _hoisted_11 = { class: "nge-blog-head-actions" }
const _hoisted_12 = {
  key: 0,
  class: "nge-blog-restore",
  role: "status"
}
const _hoisted_13 = { class: "nge-blog-field" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Title", -1 /* HOISTED */))
const _hoisted_15 = { class: "nge-blog-field" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Web address", -1 /* HOISTED */))
const _hoisted_17 = { class: "nge-blog-slug" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("code", null, "connectome.quest/blog/", -1 /* HOISTED */))
const _hoisted_19 = { class: "nge-blog-field" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Summary "),
  /*#__PURE__*/_createElementVNode("em", null, "(shown in the list of posts)")
], -1 /* HOISTED */))
const _hoisted_21 = { class: "nge-blog-field" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Feature image "),
  /*#__PURE__*/_createElementVNode("em", null, "(optional, shown in the list and at the top of the post)")
], -1 /* HOISTED */))
const _hoisted_23 = { class: "nge-blog-cover" }
const _hoisted_24 = ["src"]
const _hoisted_25 = ["disabled"]
const _hoisted_26 = { class: "nge-blog-field" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Post", -1 /* HOISTED */))
const _hoisted_28 = { class: "nge-blog-editor" }
const _hoisted_29 = ["disabled"]
const _hoisted_30 = ["disabled"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-blog-sep" }, null, -1 /* HOISTED */))
const _hoisted_32 = ["value", "disabled"]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "p" }, "Normal text", -1 /* HOISTED */))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "h2" }, "Heading", -1 /* HOISTED */))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "h3" }, "Small heading", -1 /* HOISTED */))
const _hoisted_36 = [
  _hoisted_33,
  _hoisted_34,
  _hoisted_35
]
const _hoisted_37 = ["disabled"]
const _hoisted_38 = ["disabled"]
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-blog-sep" }, null, -1 /* HOISTED */))
const _hoisted_40 = ["disabled"]
const _hoisted_41 = ["disabled"]
const _hoisted_42 = ["disabled"]
const _hoisted_43 = ["disabled"]
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-blog-sep" }, null, -1 /* HOISTED */))
const _hoisted_45 = ["disabled"]
const _hoisted_46 = ["disabled"]
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-blog-sep" }, null, -1 /* HOISTED */))
const _hoisted_48 = ["disabled"]
const _hoisted_49 = ["disabled"]
const _hoisted_50 = ["disabled"]
const _hoisted_51 = ["disabled"]
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-blog-grow" }, null, -1 /* HOISTED */))
const _hoisted_53 = ["onSubmit"]
const _hoisted_54 = ["placeholder", "aria-label"]
const _hoisted_55 = {
  class: "nge-blog-btn nge-blog-btn--primary",
  type: "submit"
}
const _hoisted_56 = {
  key: 2,
  class: "nge-blog-problem",
  role: "alert"
}
const _hoisted_57 = ["onKeydown"]
const _hoisted_58 = ["innerHTML"]
const _hoisted_59 = { class: "nge-blog-help" }
const _hoisted_60 = {
  key: 1,
  class: "nge-blog-problem",
  role: "alert"
}
const _hoisted_61 = {
  key: 2,
  class: "nge-blog-ok",
  role: "status"
}
const _hoisted_62 = ["href"]
const _hoisted_63 = { class: "nge-blog-actions" }
const _hoisted_64 = ["disabled"]
const _hoisted_65 = ["disabled"]
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-blog-grow" }, null, -1 /* HOISTED */))
const _hoisted_67 = ["disabled"]
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-blog-note" }, "Delete this post for good?", -1 /* HOISTED */))
const _hoisted_69 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["nge-blog", { 'nge-blog--site': $props.site }])
  }, [
    _createCommentVNode(" List "),
    (!$setup.editing)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", null, [
              _hoisted_2,
              _createElementVNode("p", null, [
                _createTextVNode("Posts appear on "),
                _createElementVNode("a", {
                  href: $setup.SITE,
                  target: "_blank",
                  rel: "noopener noreferrer"
                }, "connectome.quest/blog"),
                _createTextVNode(" as soon as you publish.")
              ])
            ]),
            _createElementVNode("span", _hoisted_3, [
              _createElementVNode("button", {
                class: "nge-blog-btn nge-blog-btn--primary",
                onClick: _cache[0] || (_cache[0] = $event => ($setup.open(null)))
              }, "Write a post"),
              ($props.site)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "nge-blog-btn",
                    onClick: $setup.closeEditor
                  }, "Close"))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          ($setup.problem)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString($setup.problem), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          ($setup.loading)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, "Loading posts..."))
            : (!$setup.posts.length && !$setup.problem)
              ? (_openBlock(), _createElementBlock("p", _hoisted_6, "No posts yet. Write the first one."))
              : _createCommentVNode("v-if", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.posts, (p) => {
            return (_openBlock(), _createElementBlock("button", {
              key: p.id,
              class: "nge-blog-row",
              onClick: $event => ($setup.open(p))
            }, [
              _createElementVNode("span", _hoisted_8, _toDisplayString(p.title), 1 /* TEXT */),
              _createElementVNode("span", _hoisted_9, [
                _createElementVNode("span", {
                  class: _normalizeClass(["nge-blog-pill", 'nge-blog-pill--' + p.status])
                }, _toDisplayString(p.status === 'published' ? 'Published' : 'Draft'), 3 /* TEXT, CLASS */),
                _createTextVNode(" " + _toDisplayString(p.author_name) + " · " + _toDisplayString(p.status === 'published' ? $setup.when(p.published_at) : 'edited ' + $setup.when(p.updated_at)), 1 /* TEXT */)
              ])
            ], 8 /* PROPS */, _hoisted_7))
          }), 128 /* KEYED_FRAGMENT */))
        ], 64 /* STABLE_FRAGMENT */))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createCommentVNode(" Editor "),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", {
              class: "nge-blog-btn",
              onClick: $setup.back
            }, "← All posts"),
            _createElementVNode("span", _hoisted_11, [
              _createElementVNode("span", {
                class: _normalizeClass(["nge-blog-pill", 'nge-blog-pill--' + $setup.status])
              }, _toDisplayString($setup.id === null ? 'New post' : $setup.status === 'published' ? 'Published' : 'Draft'), 3 /* TEXT, CLASS */),
              ($props.site)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "nge-blog-btn",
                    onClick: $setup.closeEditor
                  }, "Close editor"))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          ($setup.offerLocal)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("span", null, "You have unsaved changes to this post from " + _toDisplayString($setup.when($setup.offerLocal.at)) + ".", 1 /* TEXT */),
                _createElementVNode("button", {
                  class: "nge-blog-btn nge-blog-btn--primary",
                  onClick: $setup.restoreLocal
                }, "Restore them"),
                _createElementVNode("button", {
                  class: "nge-blog-btn",
                  onClick: $setup.dropLocal
                }, "Discard")
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("label", _hoisted_13, [
            _hoisted_14,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($setup.title) = $event)),
              maxlength: "160",
              placeholder: "What is the post about?"
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, $setup.title]
            ])
          ]),
          _createElementVNode("label", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($setup.slug) = $event)),
                maxlength: "80",
                placeholder: "made-from-the-title",
                onInput: _cache[3] || (_cache[3] = $event => ($setup.slugTouched = true))
              }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                [_vModelText, $setup.slug]
              ])
            ])
          ]),
          _createElementVNode("label", _hoisted_19, [
            _hoisted_20,
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($setup.summary) = $event)),
              rows: "2",
              maxlength: "400",
              placeholder: "One or two sentences."
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, $setup.summary]
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("div", _hoisted_23, [
              ($setup.coverUrl)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: $setup.coverUrl,
                    alt: "Feature image"
                  }, null, 8 /* PROPS */, _hoisted_24))
                : _createCommentVNode("v-if", true),
              _createElementVNode("button", {
                class: "nge-blog-btn",
                disabled: $setup.busy,
                onClick: $setup.addCover
              }, _toDisplayString($setup.coverUrl ? 'Replace' : 'Upload an image'), 9 /* TEXT, PROPS */, _hoisted_25),
              ($setup.coverUrl)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "nge-blog-btn",
                    onClick: _cache[5] || (_cache[5] = $event => ($setup.coverUrl = ''))
                  }, "Remove"))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", {
                class: "nge-blog-tools",
                role: "toolbar",
                "aria-label": "Formatting",
                onMousedown: $setup.toolsMouseDown
              }, [
                _createElementVNode("button", {
                  class: "nge-blog-tool",
                  title: "Undo (Ctrl+Z)",
                  "aria-label": "Undo",
                  disabled: $setup.showPreview,
                  onClick: _cache[6] || (_cache[6] = $event => ($setup.cmd('undo')))
                }, "↶", 8 /* PROPS */, _hoisted_29),
                _createElementVNode("button", {
                  class: "nge-blog-tool",
                  title: "Redo (Ctrl+Y)",
                  "aria-label": "Redo",
                  disabled: $setup.showPreview,
                  onClick: _cache[7] || (_cache[7] = $event => ($setup.cmd('redo')))
                }, "↷", 8 /* PROPS */, _hoisted_30),
                _hoisted_31,
                _createElementVNode("select", {
                  class: "nge-blog-style",
                  "aria-label": "Text style",
                  value: $setup.blockStyle,
                  disabled: $setup.showPreview,
                  onMousedown: $setup.keepSelection,
                  onChange: $setup.setStyle
                }, _hoisted_36, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_32),
                _createElementVNode("button", {
                  class: _normalizeClass(["nge-blog-tool nge-blog-tool--b", { on: $setup.isBold }]),
                  title: "Bold (Ctrl+B)",
                  "aria-label": "Bold",
                  disabled: $setup.showPreview,
                  onClick: _cache[8] || (_cache[8] = $event => ($setup.cmd('bold')))
                }, "B", 10 /* CLASS, PROPS */, _hoisted_37),
                _createElementVNode("button", {
                  class: _normalizeClass(["nge-blog-tool nge-blog-tool--i", { on: $setup.isItalic }]),
                  title: "Italic (Ctrl+I)",
                  "aria-label": "Italic",
                  disabled: $setup.showPreview,
                  onClick: _cache[9] || (_cache[9] = $event => ($setup.cmd('italic')))
                }, "I", 10 /* CLASS, PROPS */, _hoisted_38),
                _hoisted_39,
                _createElementVNode("button", {
                  class: _normalizeClass(["nge-blog-tool", { on: $setup.isUl }]),
                  title: "Bulleted list",
                  disabled: $setup.showPreview,
                  onClick: _cache[10] || (_cache[10] = $event => ($setup.cmd('insertUnorderedList')))
                }, "• List", 10 /* CLASS, PROPS */, _hoisted_40),
                _createElementVNode("button", {
                  class: _normalizeClass(["nge-blog-tool", { on: $setup.isOl }]),
                  title: "Numbered list",
                  disabled: $setup.showPreview,
                  onClick: _cache[11] || (_cache[11] = $event => ($setup.cmd('insertOrderedList')))
                }, "1. List", 10 /* CLASS, PROPS */, _hoisted_41),
                _createElementVNode("button", {
                  class: _normalizeClass(["nge-blog-tool", { on: $setup.isQuote }]),
                  title: "Quote",
                  disabled: $setup.showPreview,
                  onClick: $setup.toggleQuote
                }, "Quote", 10 /* CLASS, PROPS */, _hoisted_42),
                _createElementVNode("button", {
                  class: _normalizeClass(["nge-blog-tool", { on: $setup.isCallout }]),
                  title: "A highlighted box for a tip or a warning",
                  disabled: $setup.showPreview,
                  onClick: $setup.toggleCallout
                }, "Callout", 10 /* CLASS, PROPS */, _hoisted_43),
                _hoisted_44,
                _createElementVNode("button", {
                  class: _normalizeClass(["nge-blog-tool", { on: $setup.ask === 'link' }]),
                  title: "Link (Ctrl+K)",
                  disabled: $setup.showPreview,
                  onClick: _cache[12] || (_cache[12] = $event => ($setup.openAsk('link')))
                }, "Link", 10 /* CLASS, PROPS */, _hoisted_45),
                _createElementVNode("button", {
                  class: _normalizeClass(["nge-blog-tool", { on: $setup.ask === 'button' }]),
                  title: "A big button that opens a link",
                  disabled: $setup.showPreview,
                  onClick: _cache[13] || (_cache[13] = $event => ($setup.openAsk('button')))
                }, "Button", 10 /* CLASS, PROPS */, _hoisted_46),
                _hoisted_47,
                _createElementVNode("button", {
                  class: "nge-blog-tool",
                  title: "Add an image",
                  disabled: $setup.busy || $setup.showPreview,
                  onClick: $setup.addImage
                }, "Image", 8 /* PROPS */, _hoisted_48),
                _createElementVNode("button", {
                  class: "nge-blog-tool",
                  title: "Two images side by side",
                  disabled: $setup.busy || $setup.showPreview,
                  onClick: $setup.addImagePair
                }, "2 images", 8 /* PROPS */, _hoisted_49),
                _createElementVNode("button", {
                  class: _normalizeClass(["nge-blog-tool", { on: $setup.ask === 'video' }]),
                  title: "A YouTube video",
                  disabled: $setup.showPreview,
                  onClick: _cache[14] || (_cache[14] = $event => ($setup.openAsk('video')))
                }, "Video", 10 /* CLASS, PROPS */, _hoisted_50),
                _createElementVNode("button", {
                  class: "nge-blog-tool",
                  title: "A line between sections",
                  disabled: $setup.showPreview,
                  onClick: $setup.addDivider
                }, "Divider", 8 /* PROPS */, _hoisted_51),
                _hoisted_52,
                _createElementVNode("button", {
                  class: _normalizeClass(["nge-blog-tool", { on: $setup.showPreview }]),
                  title: "See the post as readers will",
                  onClick: $setup.togglePreview
                }, _toDisplayString($setup.showPreview ? 'Keep writing' : 'Preview'), 3 /* TEXT, CLASS */)
              ], 32 /* HYDRATE_EVENTS */),
              ($setup.ask && !$setup.showPreview)
                ? (_openBlock(), _createElementBlock("form", {
                    key: 0,
                    class: "nge-blog-ask",
                    onSubmit: _withModifiers($setup.applyAsk, ["prevent"])
                  }, [
                    ($setup.ask === 'button')
                      ? _withDirectives((_openBlock(), _createElementBlock("input", {
                          key: 0,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => (($setup.askText) = $event)),
                          maxlength: "60",
                          placeholder: "What the button says",
                          "aria-label": "Button text",
                          onKeydown: [
                            _cache[16] || (_cache[16] = _withModifiers(() => {}, ["stop"])),
                            _cache[17] || (_cache[17] = _withKeys(_withModifiers($event => ($setup.ask = null), ["prevent"]), ["esc"]))
                          ]
                        }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */)), [
                          [_vModelText, $setup.askText]
                        ])
                      : _createCommentVNode("v-if", true),
                    _withDirectives(_createElementVNode("input", {
                      ref: "askEl",
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => (($setup.askUrl) = $event)),
                      placeholder: $setup.ask === 'video' ? 'Paste a YouTube link' : 'Paste or type a web address',
                      "aria-label": $setup.ask === 'video' ? 'YouTube link' : 'Web address',
                      onKeydown: [
                        _cache[19] || (_cache[19] = _withModifiers(() => {}, ["stop"])),
                        _cache[20] || (_cache[20] = _withKeys(_withModifiers($event => ($setup.ask = null), ["prevent"]), ["esc"]))
                      ]
                    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_54), [
                      [_vModelText, $setup.askUrl]
                    ]),
                    _createElementVNode("button", _hoisted_55, _toDisplayString($setup.ask === 'video' ? 'Add video' : $setup.ask === 'button' ? 'Add button' : 'Add link'), 1 /* TEXT */),
                    ($setup.ask === 'link')
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: "nge-blog-btn",
                          type: "button",
                          onClick: $setup.removeLink
                        }, "Remove link"))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("button", {
                      class: "nge-blog-btn",
                      type: "button",
                      onClick: _cache[21] || (_cache[21] = $event => ($setup.ask = null))
                    }, "Cancel"),
                    ($setup.askError)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_56, _toDisplayString($setup.askError), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_53))
                : _createCommentVNode("v-if", true),
              _withDirectives(_createElementVNode("div", {
                ref: "docEl",
                class: "nge-blog-doc",
                contenteditable: "true",
                role: "textbox",
                "aria-multiline": "true",
                "aria-label": "Post",
                spellcheck: "true",
                onInput: $setup.keepLocalSoon,
                onPaste: $setup.onPaste,
                onClick: $setup.onDocClick,
                onKeydown: _withModifiers($setup.onDocKey, ["stop"]),
                onKeyup: _cache[22] || (_cache[22] = _withModifiers(() => {}, ["stop"])),
                onKeypress: _cache[23] || (_cache[23] = _withModifiers(() => {}, ["stop"]))
              }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_57), [
                [_vShow, !$setup.showPreview]
              ]),
              ($setup.showPreview)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "nge-blog-doc nge-blog-doc--preview",
                    innerHTML: $setup.previewHtml
                  }, null, 8 /* PROPS */, _hoisted_58))
                : _createCommentVNode("v-if", true)
            ]),
            _withDirectives(_createElementVNode("p", _hoisted_59, "Write as you would in any document. Select text and use the buttons to format it. Click a picture or video and press Delete to remove it.", 512 /* NEED_PATCH */), [
              [_vShow, !$setup.showPreview]
            ])
          ]),
          ($setup.problem)
            ? (_openBlock(), _createElementBlock("p", _hoisted_60, _toDisplayString($setup.problem), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          ($setup.message)
            ? (_openBlock(), _createElementBlock("p", _hoisted_61, [
                _createTextVNode(_toDisplayString($setup.message) + " ", 1 /* TEXT */),
                ($setup.status === 'published')
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: $setup.postUrl,
                      target: "_blank",
                      rel: "noopener noreferrer"
                    }, "View it", 8 /* PROPS */, _hoisted_62))
                  : _createCommentVNode("v-if", true)
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_63, [
            _createElementVNode("button", {
              class: "nge-blog-btn nge-blog-btn--primary",
              disabled: $setup.busy,
              onClick: _cache[24] || (_cache[24] = $event => ($setup.save('published')))
            }, _toDisplayString($setup.status === 'published' ? 'Publish changes' : 'Publish'), 9 /* TEXT, PROPS */, _hoisted_64),
            _createElementVNode("button", {
              class: "nge-blog-btn",
              disabled: $setup.busy,
              onClick: _cache[25] || (_cache[25] = $event => ($setup.save('draft')))
            }, _toDisplayString($setup.status === 'published' ? 'Unpublish (back to draft)' : 'Save draft'), 9 /* TEXT, PROPS */, _hoisted_65),
            _hoisted_66,
            ($setup.id !== null)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (!$setup.confirmDelete)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "nge-blog-btn nge-blog-btn--danger",
                        disabled: $setup.busy,
                        onClick: _cache[26] || (_cache[26] = $event => ($setup.confirmDelete = true))
                      }, "Delete", 8 /* PROPS */, _hoisted_67))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _hoisted_68,
                        _createElementVNode("button", {
                          class: "nge-blog-btn nge-blog-btn--danger",
                          disabled: $setup.busy,
                          onClick: $setup.remove
                        }, "Yes, delete", 8 /* PROPS */, _hoisted_69),
                        _createElementVNode("button", {
                          class: "nge-blog-btn",
                          onClick: _cache[27] || (_cache[27] = $event => ($setup.confirmDelete = false))
                        }, "Keep it")
                      ], 64 /* STABLE_FRAGMENT */))
                ], 64 /* STABLE_FRAGMENT */))
              : _createCommentVNode("v-if", true)
          ])
        ], 64 /* STABLE_FRAGMENT */))
  ], 2 /* CLASS */))
}